module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('ci-topbar', {
    staticClass: "light-blue",
    attrs: {
      "data": _vm.navData,
      "username": _vm.username,
      "titlename": _vm.appname
    }
  }), _vm._v(" "), _c('ci-container', [_c('ci-sidebar', {
    staticClass: "light-blue",
    attrs: {
      "data": _vm.navData,
      "titlename": _vm.appname
    }
  }), _vm._v(" "), _c('ci-content', [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-53c6d8e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 254
// module chunks = 4